import { BenefitsCard } from "../WACardWrappers";

const BenefitsCardWrap: React.FC = () => {
    return (
        <div className="flex lg:flex-row md:flex-col md:justify-center md:items-center flex-col gap-3  lg:mx-0 md:mx-0 sm:mx-0 mx-3 lg:h-72">
            <div className="lg:w-1/4 md:w-1/2 w-full lg:h-full lg:pb-0 pb-16">
                <BenefitsCard className="h-full" style={{ justifyContent: "flex-start" }}>
                    <div style={{ position: "relative" }}>
                        <img
                            alt="Qualify Your Leads Easily"
                            className="h-24 w-24"
                            src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon1.png"
                            style={{ position: "absolute", top: "-5rem", left: "50%", transform: "translate(-46%, -1%)" }}
                        />
                        <div className="flex flex-col gap-4 pt-2">
                            <h6 className="text-2xl font-medium text-gray-600 m-0 p-0 text-left">Qualify Your Leads Easily</h6>
                            <p className="text-left text-base text-gray-600">
                                Jump the lead qualification hurdle and let your chatbots do the heavy lifting with WhatsApp Forms, aka Flows.
                            </p>
                        </div>
                    </div>
                </BenefitsCard>
            </div>
            <div className="lg:w-1/4 md:w-1/2 w-full lg:h-full lg:pb-0 pb-16">
                <BenefitsCard className="h-full" style={{ justifyContent: "flex-start" }}>
                    <div style={{ position: "relative" }}>
                        <img
                            alt="Level Up Your Efficiency"
                            className=" h-24 w-24"
                            src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon2.png"
                            style={{ position: "absolute", top: "-5rem", left: "50%", transform: "translate(-46%, -1%)" }}
                        />
                        <div className="flex flex-col gap-4 pt-2">
                            <h6 className="text-2xl font-medium text-gray-600 m-0 p-0 text-left">Level Up Your Efficiency</h6>
                            <p className="text-left text-base text-gray-600 ">
                                Don’t let your qualified leads turn cold or customer inquiries unanswered by automating responses to FAQs.
                            </p>
                        </div>
                    </div>
                </BenefitsCard>
            </div>
            <div className="lg:w-1/4 md:w-1/2 w-full lg:h-full lg:pb-0 pb-16">
                <BenefitsCard className="h-full" style={{ justifyContent: "flex-start" }}>
                    <div style={{ position: "relative" }}>
                        <img
                            alt="Send Bulk Broadcasts"
                            className=" h-24 w-24"
                            src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon3.png"
                            style={{ position: "absolute", top: "-5rem", left: "50%", transform: "translate(-46%, -1%)" }}
                        />
                        <div className="flex flex-col gap-4 pt-2">
                            <h6 className="text-2xl font-medium text-gray-600 m-0 p-0 text-left">Send Bulk Broadcasts </h6>
                            <p className="text-left text-base text-gray-600 ">
                                Create targeted broadcasts and nurture your prospect pipeline until they’re ready to move ahead and buy from you.
                            </p>
                        </div>
                    </div>
                </BenefitsCard>
            </div>
            <div className="lg:w-1/4 md:w-1/2 w-full lg:h-full">
                <BenefitsCard className="h-full" style={{ justifyContent: "flex-start" }}>
                    <div style={{ position: "relative" }}>
                        <img
                            alt="Amplify Your Marketing ROI"
                            className=" h-24 w-24"
                            src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon4.png"
                            style={{ position: "absolute", top: "-5rem", left: "50%", transform: "translate(-46%, -1% )" }}
                        />
                        <div className="flex flex-col gap-4 pt-2">
                            <h6 className="text-2xl font-medium text-gray-600 m-0 p-0 text-left">Amplify Your Marketing ROI</h6>
                            <p className="text-left text-base text-gray-600 ">
                                Don’t take the risk of the highly qualified paid leads that land on your website running cold; make the most out of your ad campaigns.
                            </p>
                        </div>
                    </div>
                </BenefitsCard>
            </div>
        </div>
    );
};
export default BenefitsCardWrap;
